var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":_vm.url}},[_c('img',{staticClass:"object-cover",attrs:{"src":_vm.preview,"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }